<script>
  import gsap from 'gsap'
  import { ga } from '@beyonk/svelte-google-analytics'

  export let id = ''
  export let color = 'gray'
  let hidden = true
  let sourceBox, wrapEl

  function toggle (e) {
    hidden = !hidden
    if(!hidden) {
      sourceBox.style.cssText = ''
      document.querySelector('main').append(sourceBox)
      const boxHeight = gsap.getProperty(sourceBox, 'height')
      const x = wrapEl.getBoundingClientRect().left - document.querySelector('main').getBoundingClientRect().left
      let y = wrapEl.getBoundingClientRect().top - boxHeight - 30
      if(y < gsap.getProperty('header', 'height') + 20) {
        y += boxHeight + 60
      }
      y += document.documentElement.scrollTop
      gsap.set(sourceBox, {top: y, left: x})
      try {
        ga.addEvent('toggle_view_source', {
          id, open: !hidden
        })
      } catch(e) {
        console.log(e)
      }
      setTimeout(() => {
        document.body.addEventListener('click', clickToHide)
      }, 100)
    } else {
      clickToHide(e)
    }
  }
  function clickToHide (e) {
    if(!e.target.closest('.source-box')) {
      hidden = true
      document.body.removeEventListener('click', clickToHide)
      try {
        ga.addEvent('toggle_view_source', {
          id, open: hidden
        })
      } catch(e) {
        console.log(e)
      }
    }
  }
</script>
<div class="view-source-wrap" bind:this={wrapEl}>
  <div class="source-box" class:hidden={hidden} bind:this={sourceBox}>
    <button class="custom close-btn" aria-label="Close" on:click|preventDefault={toggle}>
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g fill="currentColor">
          <path d="M12.7328 0.00491333L0.00492085 12.7324L0.712026 13.4395L13.4399 0.711996L12.7328 0.00491333Z"/>
          <path d="M13.4399 12.7441L0.711988 0.0156588L0.00488281 0.722793L12.7328 13.4512L13.4399 12.7441Z"/>
        </g>
      </svg>
    </button>
    <p><strong>Source:</strong>
      <slot></slot>
    </p>
  </div>
  <button class="custom text-btn source-btn {color}" on:click|preventDefault={toggle}>View source</button>
</div>
<style>
  .view-source-wrap {
    margin: 1rem 0 2rem;
    position: relative;
  }
  .source-btn {
    font-size: 0.75rem;
    font-weight: normal;
  }
  .source-box {
    opacity: 1;
    transform: scale3d(1,1,1);
    transition: 300ms cubic-bezier(0.645, 0.045, 0.355, 1);
    transition-property: opacity, transform;
    background: var(--gray-line);
    padding: var(--gutter-sm);
    min-height: 160px;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 100;
    max-width: 440px;
  }
  .source-box :global(a) {
    color: inherit;
  }
  .source-box.hidden {
    opacity: 0;
    transform: scale3d(0.5, 0.5, 0.5);
    pointer-events: none;
  }
  .source-box p {
    margin: 0;
    padding: 50px 0;
  }
  .close-btn {
    position: absolute;
    padding: 5px;
    top: calc(var(--gutter-sm) - 5px);
    right: calc(var(--gutter-sm) - 5px);
  }
  .view-source-wrap :global(a) {
    color: inherit;
    text-decoration: underline;
  }
</style>